export enum ServiceStatus {
  DOWN = 'DOWN',
  IN_PROGRESS = 'IN_PROGRESS',
  LIVE = 'LIVE',
}

export enum SandboxStatus {
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export const serviceStatuses = Object.values<string>(ServiceStatus);
